// extracted by mini-css-extract-plugin
export default {"wrapper":"Td","form":"Ud","smallprint":"Vd","asterisk":"Wd","success":"Xd","circle":"Yd","button":"Zd"};